import { twMerge } from "tailwind-merge";
import Flex from "~/components/flex/Flex";
import { Icon, IconName } from "~/components/icons/Icon";
import Text from "~/components/texts/Text";
import { TranslateType } from "~/types-and-enums/generalTypes";
import { PofeType } from "~/types-and-enums/purchaseOrderTypes";

/**
 * POFE Product Details component
 * @param pofe - The POFE to display the products for
 * @param className - The class name to apply to the component
 * @param translate - The translation function to use
 * @returns
 */
const POFEPProductDetails = ({
  pofe,
  className,
  translate,
}: {
  pofe: PofeType;
  className?: string;
  translate: TranslateType;
}) => (
  <Flex className={twMerge("w-full flex-col gap-2 justify-center items-center", className)}>
    {pofe.pofeps.map((pofep) => (
      <Flex key={pofep.id} className="w-full justify-between items-center">
        <Flex className="gap-2 items-center">
          <Icon name={IconName.Modules} size={12} customStrokeWidth={1.5} className="text-gray-500" />
          <Text fontWeight="medium" className="text-gray-500 text-wrap text-[10px] md:text-xs flex-1">
            {pofep.product_name}
          </Text>
        </Flex>
        <Text fontWeight="semibold" className="min-w-[80px] text-[10px] md:text-xs ml-2">
          {pofep.quantity} {translate("general.pieces").toLowerCase()}
        </Text>
      </Flex>
    ))}
    {pofe.pofeps.length === 0 && (
      <Text className="text-gray-400 text-xs md:text-sm italic">{translate("general.no-products")}</Text>
    )}
  </Flex>
);

export default POFEPProductDetails;
